export const getFieldNameWithPrefix = (
  name: string,
  prefix?: string | number,
): string => (prefix ? `${prefix}.${name}` : name);
